export interface IDateRangeFacet {
    name: string;
    start: string;
    end: string;
 }

